import { Investment } from '@tcs/client-portal-api/types/Investment';

/*TCS-833 - Business rule
    In the assets table, we should display # Units and Unit Value for investment balances that contain this information. Logic is as follows:
      *If TotalUnits == InvestmentValue && UnitValue == 1  OR the AssetType == RealEstate then this is not a share based asset, just display the investment value and put N/A in for the other fields
      *We will handle RealEstate in a follow-on ticket. The TotalUnits in the database is actually the % owned and the UnitValue is the overall value of the property,  so it does not make sense to show them in the same way as the other unit based assets
    Else show the total units, unit value, and investment value in the table.*/
export const doesInvestmentHaveUnits = (investment: Investment) => {
  if (
    (investment.totalUnits === investment.investmentValue &&
      investment.unitValue === 1) ||
    investment.assetType === 'RealEstate'
  ) {
    return false;
  }
  return investment.totalUnits > 0;
};
